import { gql } from '@apollo/client';

export const ADDRESS_FIELDS = gql`
  fragment AddressFields on Address {
    street
    streetNumber
    streetExtra
    postcode
    city
    country
  }
`;

export const DIMENSIONS_2D_FIELDS = gql`
  fragment Dimensions2DFields on Dimensions2D {
    width
    height
  }
`;

export const COORDINATES_FIELDS = gql`
  fragment CoordinatesFields on Coordinates {
    x
    y
  }
`;

export const COORDINATES_3D_FIELDS = gql`
  fragment Coordinates3DFields on Coordinates3D {
    x
    y
    z
  }
`;

export const POINT_OF_VIEW_3D_FIELDS = gql`
  fragment PointOfView3DFields on PointOfView3D {
    pitch
    yaw
    radius
  }
`;

export const MEDIA_FIELDS = gql`
  fragment MediaFields on Media {
    url
    contentBase64
    contentType
  }
`;

export const IMAGE_FIELDS = gql`
  ${MEDIA_FIELDS}
  fragment ImageFields on Image {
    hash
    size
    media {
      ...MediaFields
    }
  }
`;

export const MONEY_FIELDS = gql`
  fragment MoneyFields on Money {
    currency
    amount
  }
`;

export const TRANSLATED_STRING_FIELDS = gql`
  fragment TranslatedStringFields on TranslatedString {
    en
    nl
    fr
    du
  }
`;

export const DIMENSIONS_3D_FIELDS = gql`
  fragment Dimensions3DFields on Dimensions3D {
    width
    height
    depth
  }
`;

export const POLY_SHAPE_FIELDS = gql`
  ${MEDIA_FIELDS}
  fragment PolyShapeFields on PolyShape {
    mediaDefined {
      ...MediaFields
    }
  }
`;

export const SHAPE_FIELDS = gql`
  ${POLY_SHAPE_FIELDS}
  fragment ShapeFields on Shape {
    polyShape {
      ...PolyShapeFields
    }
  }
`;

// --------------------------------------------------------- Designer theme ---------------------------------------------------------

export const DESIGNER_THEME_BASIC_PROFILE_FIELDS = gql`
  fragment DesignerThemeBasicProfileFields on DesignerThemeBasicProfile {
    overallDesignerBck
    overallDesignerContent
    designerPanelBck
    designerPanelContent
    designerPanelControlsActiveBck
    designerPanelControlsActiveContent
    designerPanelControlsInactiveBck
    designerPanelControlsInactiveContent
    fontType
  }
`;

// --------------------------------------------------------- Delivery Unit ---------------------------------------------------------
export const DELIVERY_UNIT_FIELDS = gql`
  ${ADDRESS_FIELDS}
  fragment DeliveryUnitFields on DeliveryUnit {
    id
    partyId
    name
    address {
      ...AddressFields
    }
    createdAt
    updatedAt
  }
`;
